/* eslint-disable class-methods-use-this */
/* global logger */
const { freightUnit } = require('../../constants/payments');
const { orderType, PaymentCharge } = require('pando-constants');
const Helper = require('./utils/helper');

class BaseDieselRate {
  constructor(isMaxFreightBdrEnabled = false) {
    this.isMaxFreightBdrEnabled = isMaxFreightBdrEnabled;
  }
  calculateBdrCharge(contract, freightUnitGroups, destination,
    materialMap, packageMap, quantityUnitsForPieces, freightBasedBdr, gateId = '') {
    const freightUnitGroup = freightUnitGroups;
      if (contract) {
      if (contract.freightUnit === freightUnit.per_trip ||
        contract.freightUnit === freightUnit.per_km) {
        if (!freightUnitGroup[contract.freightUnit]) {
          freightBasedBdr[contract.freightUnit] =  
          { 
            [PaymentCharge.BDR]: contract.bdrCharge,
            [PaymentCharge.FREIGHT]: contract.freightCharge
          }
          freightUnitGroup[contract.freightUnit] = contract.bdrCharge;
        }
        if (this.isMaxFreightBdrEnabled) {
          if(freightBasedBdr[contract.freightUnit] &&
            freightBasedBdr[contract.freightUnit][PaymentCharge.FREIGHT] < contract.freightCharge) {
            freightUnitGroup[contract.freightUnit] = contract.bdrCharge;
            freightBasedBdr[contract.freightUnit][PaymentCharge.FREIGHT] = contract.freightCharge;
            freightBasedBdr[contract.freightUnit][PaymentCharge.BDR] = contract.bdrCharge;
          }
        } else {
          freightUnitGroup[contract.freightUnit] = Math.max(contract.bdrCharge, freightUnitGroup[contract.freightUnit]);
        }
      } else {
        if (!freightUnitGroup[contract.freightUnit]) {
          freightUnitGroup[contract.freightUnit] = 0;
          freightBasedBdr[contract.freightUnit] = 
          { 
            [PaymentCharge.BDR]: 0,
            [PaymentCharge.FREIGHT]: contract.freightCharge
          };
        }
        const unitType = contract.freightUnit;
        const destinationMaterials = Helper.getMaterialsForDestination(destination, gateId);
        freightUnitGroup[contract.freightUnit] += Helper.calculateQuantity(
          destinationMaterials, unitType, materialMap, packageMap,
          contract, 'bdrCharge', quantityUnitsForPieces);
      }
    }
    return freightUnitGroup;
  }


  fixedBdrCharge(data) {
    let freightUnitGroup = {};
    const freightBasedBdr = {};
    const freightContracts = data.freightCharges;
    const quantityUnitsForPieces = Helper
      .getQuantityUnitsForPieces(data.customQuantityUnits);
    const materialMap = Helper.fetchMaterialMap(data.materials.masterData);
    const packageMap = Helper.fetchPackageMap(data.packages.masterData);
    if (data.orderType === orderType.OPEN) {
      return 0;
    }

    const gateIds = [...new Set(freightContracts.filter(contract => contract.sourceGateId)
      .map(contract => contract.sourceGateId.toString()))];

    data.destinations.forEach((destination) => {
      // added condition here since secondary consignees will not have gate id
      if (gateIds.length) {
        logger.info(`[BDR] - debug gateIds - ${JSON.stringify(gateIds)}`);
        gateIds.forEach((gateId) => {
          logger.info(`[BDR] - debug gateId - ${JSON.stringify(gateId)}`);
          const contractCharge = freightContracts.find((contract) => {
            if (contract.destinationGateId) {
              return (contract.sourceGateId.toString() === gateId &&
                  contract.destinationId.toString() === destination.locationId.toString() &&
                  contract.destinationGateId.toString() === destination.destinationGateId.toString());
            }
            return (contract.sourceGateId.toString() === gateId &&
                  contract.destinationId.toString() === destination.locationId.toString());
          });
          logger.info(`[BDR] - debug contractCharge - ${JSON.stringify(contractCharge)}, gateId - ${JSON.stringify(gateId)}`);
          freightUnitGroup = this.calculateBdrCharge(contractCharge,
            freightUnitGroup, destination, materialMap, packageMap, quantityUnitsForPieces, freightBasedBdr, gateId);
        });
      } else {
        const contractCharge = freightContracts.find(contract =>
          contract.destinationId.toString() === destination.locationId.toString());
        freightUnitGroup = this.calculateBdrCharge(contractCharge,
          freightUnitGroup, destination, materialMap, packageMap, quantityUnitsForPieces, freightBasedBdr);
        logger.info(`[BDR] - debug contractCharge - ${JSON.stringify(contractCharge)}, locationId - ${JSON.stringify(destination.locationId)}`);
      }
    });
    if (freightUnitGroup[freightUnit.per_trip]) {
      return freightUnitGroup[freightUnit.per_trip];
    }
    if (freightUnitGroup[freightUnit.per_km]) {
      return freightUnitGroup[freightUnit.per_km];
    }
    const freightCharges = Object.values(freightUnitGroup);
    if (freightCharges.length) {
      const freightCharge = Math.max(...Object.values(freightUnitGroup));
      return freightCharge;
    }
    return 0;
  }
}
module.exports = BaseDieselRate;
